import authService from './authService';

const BASE_URL = process.env.REACT_APP_API_URL;

export async function getInstitutions(query:string, perPage:number, pageNo:number) {
    try {
      const response = await authService.apiCall(`${BASE_URL}/tenant?query=${query}&perPage=${perPage}&pageNo=${pageNo}`, {
        method: 'GET',
      });

     // console.log(response);

      if (!response.ok) {
        throw new Error('Failed to get institutions');
      }

      const result = await response.json();
     // console.log('Institutions fetched successfully:', result);
      return result;
    } catch (error) {
      console.error('Error fetching institutions:', error);
      throw new Error('Error fetching institutions');
    }
}

export async function getAnnouncement(query:string, perPage:number, pageNo:number) {
    try {
      const response = await authService.apiCall(`${BASE_URL}/announcements?query=${query}&perPage=${perPage}&pageNo=${pageNo}`, {
        method: 'GET',
      });

      if (!response.ok) {
        throw new Error('Failed to get announcement');
      }

      const result = await response.json();
     // console.log('Announcement fetched successfully:', result);
      return result;
    } catch (error) {
      console.error('Error fetching announcement:', error);
        throw new Error('Error fetching announcement');
    }
}